import { render, staticRenderFns } from "./CatalogPages.vue?vue&type=template&id=31628d55&"
import script from "./CatalogPages.vue?vue&type=script&lang=js&"
export * from "./CatalogPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports